<div class="color-div">
  <mat-label class="label">{{label | translate}}</mat-label>
  <div [(colorPicker)]="color" [cpDisabled]="isDisabled" [style.background]="color" [cpPresetColors]="presetColors" (colorPickerClose)="colorClose()" (colorPickerChange)="colorChange($event)" [cpPosition]="position" class="color"></div>
</div>
